"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_KEY_PART_LENGTH = exports.PUBLIC_KEY_LENGTH = exports.ETH_ADDRESS_LENGTH = void 0;
exports.ETH_ADDRESS_LENGTH = 42;
exports.PUBLIC_KEY_LENGTH = 132;
exports.PUBLIC_KEY_PART_LENGTH = (exports.PUBLIC_KEY_LENGTH - 4) / 2 + 2;
